import Viewport from './Viewport';

function App() {
  return <Viewport />;
}

export default App;
